import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/AppShell";
import { AppModeProvider } from "@/mode";
import { PromotionCheckIn } from "@/components/promo/PromotionCheckIn";
import { fetchMeOrNull } from "@/lib/auth";
import { keys } from "@/lib/queries";
import { useOrderStatusStream } from "@/hooks/useOrderStatusStream";
import { useSessionBoundary } from "@/hooks/useSessionBoundary";
import { useWatchlistSync } from "@/lib/useWatchlist";

// App layout route. Warms the session (never throws — anonymous renders fine),
// drops the previous session's private cache when the session changes, and
// mounts the order/position WS toast bridge once for the whole app. The
// VISIT campaign heartbeat (SM-618) hangs off the session here too: it
// checks in for a signed-in user and shows the reward popup when a visit
// credited something.
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context }) => {
    await context.queryClient
      .ensureQueryData({ queryKey: keys.me(), queryFn: fetchMeOrNull })
      .catch(() => null);
  },
  component: AppLayout,
});

function AppLayout() {
  useSessionBoundary();
  useOrderStatusStream();
  useWatchlistSync();
  return (
    // The trading-mode provider wraps the whole authenticated app
    // (SM-441): mode is a property of the session, not of a page, and
    // every mode-scoped query key is built from it. It sits inside the
    // shell so the switch in the header is under the same context it
    // drives.
    <AppModeProvider>
      <AppShell>
        <Outlet />
        <PromotionCheckIn />
      </AppShell>
    </AppModeProvider>
  );
}
